//Componentes generales
import React, { useState, useEffect, useMemo } from 'react';
import UserInfo from '../../components/UserInfo/UserInfo';
import FormUser from '../FormUser/FormUser';
import SearchInput from "../../components/searchInput/SearchInput";
import AddItm from '../addItm/AddItm';
import QRCode from 'react-qr-code';
import * as XLSX from 'xlsx';
import { Download } from 'react-feather';

// Estilos
import './UserList.css';
import normalizeText from "../../utils/normalizeText";
import {COLOR_FONDO} from '../../constants/colors';

// Iconos
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faUserAlt,
    faPenToSquare,
    faTrash,
    faEye,
    faBracketCurlyRight,
    faMobileAndroid,
    faAppleAlt,
    faPencil,
    faSave,
    faCrutch,
    faX
} from "@fortawesome/free-solid-svg-icons";

/* 
    Componente encargado de mostrar listado de usuarios.
        Donde list es el listado de usuarios.
              verModificar es la función del context que oculta el dialog de modificación de usuario.
              estadoVerModificar es la función del context que muestra el dialog de modificación de usuario.
              saveModificacion es la función del context encargada de guardar un usuario nuevo o modificado.
              verUser es la función del context que muestra el dialog de detalle de usuario.
              seleccionado es el usuario seleccionado de la lista.
              eliminarUser es la función del context que elimina un usuario (tiene que cumplir ciertas condiciones).
              verficaCantidadUser es la función del context que controla la cantidad de usuarios habilitados contra la cantidad en su licencia.

*/
function UserList({ list = [], verModificar, estadoVerModificar, saveModificacion, verUser, seleccionado, eliminarUser, verificaCantidadUsers, listGroups, usuario }) {

    //state para mostrar el dialog de información usuario.
    const [showUserInfo, setShowUserInfo] = useState(false);
    //state titulo del dialog a utilizar.
    const [title, setTitle] = useState('');
    //state del filtro por busqueda.
    const [filter, setFilter] = useState("");
    //state de cantidades de usuarios
    const [controlUsuarios, setControlUsuarios] = useState({userEnabled: 0, maxUsersEnabled: 0, totalUsers: 0 });
    //state de links de descarga desde Discover
    const [discoverLinks, setDiscoverLinks] = useState({ appAndroid: null, appIOS: null });

    useEffect(() => {
        //Recupera usuarios habilitados y seteo state de control.
        const verificar = async () => {
            const licenciaUsuario = await verificaCantidadUsers();
            setControlUsuarios({...licenciaUsuario.data, totalUsers: list.length});
        }
        verificar();
    },[list]);

    useEffect(() => {
        if (!usuario?.tenantId) return;
        const fetchDiscoverLinks = async () => {
            try {
                const [androidResp, iosResp] = await Promise.all([
                    fetch(`https://discover.xertux.com/api/tenant/discoverPlatform/${usuario.tenantId}/XMANT_ANDROID`, {
                        headers: { 'x-api-key': 'xertux_discover_api_key_2024' }
                    }),
                    fetch(`https://discover.xertux.com/api/tenant/discoverPlatform/${usuario.tenantId}/XMANT_IOS`, {
                        headers: { 'x-api-key': 'xertux_discover_api_key_2024' }
                    })
                ]);
                const androidData = await androidResp.json();
                const iosData = await iosResp.json();
                setDiscoverLinks({
                    appAndroid: androidData?.data?.link || null,
                    appIOS: iosData?.data?.link || null
                });
            } catch (error) {
                console.log("Error fetching discover links:", error);
            }
        };
        fetchDiscoverLinks();
    }, [usuario?.tenantId]);
/*   */
   
    const checkEstadoVisibilidad = (usuario) => {
        verUser(usuario);
        showUserInfo ? setShowUserInfo(false) : setShowUserInfo(true);
    }

    /* 
        Función que determina si mostrar el formulario para editar el usuario seleccionado.
            Donde user es el usuario seleccionado de la lista.
        Se setea el titulo encabezado del formulario.
    */
    const enviarModificar = (user) =>{
        setTitle('Modificar Usuario');
        verModificar(user);
    }

    /* 
        Función que determina si mostrar el formulario para agregar un nuevo usuario.
            Donde user es el usuario seleccionado (no esta en uso).
        Se setea el titulo encabezado del formulario.
    */
    const enviarAgregar = (user) =>{
        setTitle('Nuevo Usuario');
        verModificar(user);
    }

    /* 
        Función que setea el filtro de busqueda.
            Donde data es lo ingresado por el usuario.
    */
    const handdlerSearchInput = (data) =>{
        setFilter(data);
    }

    const exportarUsersXlsx = () => {
        const aoa = [
            ["UserName", "Nombre Completo", "Número de Socio", "Habilitado"],
            ...list.map(u => [
                u.userName || "",
                u.fullName || "",
                u.nroSocio || "",
                u.enabled ? "S" : "N",
            ]),
        ];
        const ws = XLSX.utils.aoa_to_sheet(aoa);
        ws['!cols'] = [{ wch: 20 }, { wch: 28 }, { wch: 16 }, { wch: 12 }];
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Users');
        XLSX.writeFile(wb, 'Users.xlsx');
    }

    const MAX_USUARIOS_VISIBLES = 50;

    let usersFiltered = useMemo(()=> {
        const filtered = list.filter(user => {
            return filter.length >= 3 ?
                (filter.charAt(0) == '"' && filter.charAt(filter.length - 1) == '"') ?
                    (normalizeText(user.fullName) == normalizeText(filter.replaceAll('"','')) || normalizeText(user.userName) == normalizeText(filter.replaceAll('"','')))
                :
                    (normalizeText(user.fullName).includes(normalizeText(filter)) || normalizeText(user.userName).includes(normalizeText(filter)))
            : true
        });
        // Sin filtro activo, mostrar solo los primeros N usuarios
        if (filter.length < 3) return filtered.slice(0, MAX_USUARIOS_VISIBLES);
        return filtered;
    }, [list,filter])

    return (
        <div>
            <AddItm titulo='usuario' anadiritm={enviarAgregar} />
            <SearchInput buscar={handdlerSearchInput} filter={filter}/>
            <div className='container-user-list'>
                <div style={{display:'flex', alignItems:'center', marginTop:24}}>
                    <article style={{width:'60%', marginLeft:'20%', paddingBottom:'1rem', paddingTop:'1rem',  justifyContent:'center'}}>
                        <div className='container-list-item-infoo' style={{width:'100%', display:'flex', flexDirection:'column', backgroundColor: COLOR_FONDO}}>  
                            <div className='cant-user' style={{
                                /*Si borro backgroundColor, todo se ve igual!*/
                                backgroundColor: COLOR_FONDO,paddingRight:16, paddingLeft:16
                            }}>
                                <div className='cant-user-cont1'>Cantidad de usuarios</div>
                                <div className='cant-user-img'>&#123;</div>
                                <div className='cant-user-cont2'>
                                    <div className='cant-user-items'>Licencia<div className='cant-user-number'>{controlUsuarios.maxUsersEnabled}</div> </div>          
                                    <div className='cant-user-items'>Habilitados<div className='cant-user-number'>{controlUsuarios.userEnabled}</div> </div>
                                    <div className='cant-user-items'>Deshabilitados<div className='cant-user-number'>{controlUsuarios.totalUsers - controlUsuarios.userEnabled}</div> 
                                </div>     
                            </div>
                            <div className='cant-user-img2'>|</div>
                            <div className='cant-user-cont3'>{controlUsuarios.totalUsers}</div>
                            {(discoverLinks.appAndroid || discoverLinks.appIOS) && <div className='divQRs'>
                                    <div className='containerQRs'>
                                        {discoverLinks.appAndroid && <div className='qrLinkAppDiv'>
                                            <h4>Android</h4>
                                            <QRCode style={{width:90, height:90}} value={discoverLinks.appAndroid}/>
                                            <h5>{usuario.tenantId}</h5>
                                        </div>}
                                        {discoverLinks.appIOS && <div className='qrLinkAppDiv'>
                                            <h4>iOS</h4>
                                            <QRCode style={{width:90, height:90}} value={discoverLinks.appIOS}/>
                                            <h5>{usuario.tenantId}</h5>
                                        </div>}
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </article>
                <button
                    className="download-users-xlsx-btn"
                    onClick={exportarUsersXlsx}
                >
                    <Download size={14} style={{marginRight:6}} />
                    Descargar .xlsx
                </button>
            </div>

                {usersFiltered.map((user) => (
                        <article key={user.userName}>
                            <div className='container-list'>
                                <li>
                                    <div className='container-list-item'>
                                        <div className='list-item-icon'><FontAwesomeIcon icon={faUserAlt} /></div>
                                        <div className='container-list-item-each'>
                                            <div className='label'>Usuario</div>
                                            <div id='item-user' className='list-item-name' style={{backgroundColor: COLOR_FONDO}}>{user.userName}</div>
                                        </div>
                                        <div className='container-list-item-each'>
                                            <div className='label'>Nombre</div>
                                            <div className='list-item'>{user.fullName}</div>
                                        </div>
                                        <div className='container-list-item-each'>
                                            <div className='label'>Email</div>
                                            <div className='list-item'>{user.email}</div>
                                        </div>
                                        <div className='container-list-item-each'>
                                            <div className='label'>Rol</div>
                                            {user.userType.map(function (itemType, index) {
                                                return (
                                                    <div key={itemType._id} className='list-item-rol' style={{backgroundColor: COLOR_FONDO}}>{itemType.descr}</div>
                                                );
                                            })}
                                        </div>
                                        <div className='container-list-item-each'>
                                            <div className='label'>Habilitado</div>
                                            <div style={{textAlign: 'center'}}><input type="checkbox" checked={user.enabled} className='list-item-check' disabled></input></div>

                                        </div>

                                        <div className='acciones-container' style={{backgroundColor: COLOR_FONDO}}>
                                            <FontAwesomeIcon icon={faPenToSquare} className='icon' onClick={() => enviarModificar(user)} />
                                            <FontAwesomeIcon icon={faTrash} className='icon' onClick={() => eliminarUser(user)} />
                                            <FontAwesomeIcon icon={faEye} className='icon' onClick={() => checkEstadoVisibilidad(user)} />
                                        </div>
                                    </div>
                                </li>
                            </div>
                        </article>
                ))}
                {filter.length < 3 && list.length > MAX_USUARIOS_VISIBLES && (
                    <div style={{ textAlign: 'center', padding: '16px', color: '#6b7280', fontSize: '0.9em' }}>
                        Mostrando {MAX_USUARIOS_VISIBLES} de {list.length} usuarios. Usa el buscador para encontrar más.
                    </div>
                )}
            </div>
            {showUserInfo &&
                <div className='modalUser'>
                    <UserInfo user={seleccionado} verCerrarSesion={false} mode={checkEstadoVisibilidad} />
                </div>
            }
            {estadoVerModificar &&
                <div className='modalUser'>
                    <FormUser data={seleccionado} minimizar={verModificar} generar={saveModificacion} titulo={title} verificaUser={verificaCantidadUsers} licenciaUsuarios={verificaCantidadUsers} usuariosHabilitados={() => (list.filter((d) => d.enabled)).length } listGroups={listGroups} />
                </div>
            }
        </div>
    );
}

export default UserList;